import ServicesConstants from "../services/Constants";

const Constants = {
  ...ServicesConstants,
};

export default Constants;
